module.exports = __webpack_public_path__ + "static/media/GSAP Icon.61766b2f.png";